import { useEffect } from "react";

export function SEO({ title, description }) {
  useEffect(() => {
    document.title = title;
    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.setAttribute("name", "description");
      document.head.appendChild(meta);
    }
    meta.setAttribute("content", description);
  }, [title, description]);
  return null;
}

export const DISCORD_URL = "https://discord.gg/FsFnn9NuF3";

export const fadeUp = {
  hidden: { opacity: 0, y: 24 },
  visible: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, delay: i * 0.12, ease: [0.21, 0.65, 0.35, 1] },
  }),
};

export const staggerContainer = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.15 } },
};

export const cardReveal = {
  hidden: { opacity: 0, y: 28 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.55, ease: [0.21, 0.65, 0.35, 1] },
  },
};

export function PageHeader({ eyebrow, title, subtitle }) {
  return (
    <div className="relative overflow-hidden pt-36 pb-16 lg:pt-44 lg:pb-20">
      <div className="absolute inset-0 grid-pattern pointer-events-none" />
      <div
        className="absolute -top-24 left-1/2 -translate-x-1/2 w-[800px] h-[400px] pointer-events-none"
        style={{
          background:
            "radial-gradient(circle, rgba(147,51,234,0.2) 0%, rgba(9,10,15,0) 70%)",
        }}
      />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {eyebrow && (
          <p className="text-xs font-mono uppercase tracking-[0.25em] text-purple-400 mb-4">
            {eyebrow}
          </p>
        )}
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-white leading-[1.08]">
          {title}
        </h1>
        {subtitle && (
          <p className="mt-5 max-w-2xl text-base sm:text-lg text-slate-300 leading-relaxed">
            {subtitle}
          </p>
        )}
      </div>
    </div>
  );
}
